import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/AdmissionPageComponents/HeroSection/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/AdmissionPageComponents/HowToApply/HowToApply.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Common/ExplorePrograms/ExplorePrograms.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Common/FooterCard/FooterCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Common/VideoPlayer/VideoPlayer.tsx");
